<template>
  <div>
    <Toolbar :handle-delete="del">
      <template slot="left">
        <v-toolbar-title v-if="item">{{
          `${$options.servicePrefix} ${item["@id"]}`
        }}</v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-animation-show">
      <v-simple-table>
        <template slot="default">
          <tbody>
            <tr>
              <tb>
                <v-col offset-md="2" cols="10" sm="6" md="6">
                  {{ item["nom"] }}
                </v-col>
              </tb>
              <tb>
                <v-col offset-md="2" cols="10" sm="6" md="6">
                  {{ formatDateTime(item["dateDebut"], "long") }}
                </v-col>
              </tb>
              <tb>
                <v-col offset-md="2" cols="10" sm="6" md="6">
                  {{ formatDateTime(item["dateFin"], "long") }}
                </v-col>
              </tb>
              <tb>
                <v-col offset-md="2" cols="10" sm="6" md="6">
                  {{ item["localisation"].nom }}, {{ item["evenement"].nom }}, {{ item["animationType"].nom }}, {{ item["animationCategories"].nom }}
                </v-col>
              </tb>
              <tb>
                <v-col offset-md="2" cols="10" sm="6" md="6">
                  <img v-bind:src="item['image']" />
                </v-col>
              </tb>
              <tb>
                <v-col offset-md="2" cols="10" sm="6" md="6">
                  {{ item["descriptionCourt"] }}
                </v-col>
              </tb>
              <tb>
                <v-col offset-md="2" cols="10" sm="6" md="6">
                  <span v-html="item['descriptionComplet']"></span>
                </v-col>
              </tb>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import Loading from "../../components/Loading";
import ShowMixin from "../../mixins/ShowMixin";
import Toolbar from "../../components/Toolbar";

const servicePrefix = "Animation";

export default {
  name: "AnimationShow",
  servicePrefix,
  components: {
    Loading,
    Toolbar,
  },
  mixins: [ShowMixin],
  computed: {
    ...mapFields("animation", {
      isLoading: "isLoading",
    }),
    ...mapGetters("animation", ["find"]),
  },
  methods: {
    ...mapActions("animation", {
      deleteItem: "del",
      reset: "reset",
      retrieve: "load",
    }),
  },
};
</script>
